import { Alert, Backdrop, Button, Container, FormControl, FormHelperText, Grid, InputLabel, MenuItem, Paper, Select } from "@mui/material";
import { Box, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import CustomHeader from "../../../core/components/common/custom-header.component";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../../core/components/ui/CustomButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import CircularProgress from '@mui/material/CircularProgress';
import dayjs from "dayjs";
import UserService from "../service/api/user";
import CustomModal1 from "../../../core/components/ui/custom-modal1.component";
import SavePasswordDialogComponent from "../../OrganizationPlugin/components/save-password-dialog.component";
import useAdminProfileUtils from "../../ProfilePlugin/utils/useAdminProfileUtils";
import { useRBAC } from "../../RBACPlugin";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css'; 
import CustomTextField from "../../../core/components/ui/CustomTextfield";
import { useSnackbar } from "notistack";



export default function UserCreatePage() {

    const rbacStorage = JSON.parse(localStorage.getItem("rbac-storage"));
    const org_uid = rbacStorage?.state?.currentProfile?.orgId || null;

    const view_org_uid = new URLSearchParams(window.location.search).get("org_uid");

    const organizationId = view_org_uid || org_uid;

    const { isFetchingIDTypes, idTypes, getIDTypesUtil, isFetchingProfileTypes, profileTypes, getProfileTypesUtil  } = useAdminProfileUtils();

    const {getRoleByProfileType,  rolesList} = useRBAC()

    const [firstname, setFirstname] = useState('');
    const [lastname, setLastname] = useState('');
    const [email, setEmail] = useState('');
    const [birthdate, setBirthdate] = useState(null);
    const [middlename, setMiddleName] = useState("");
    const [contact_no, setContactNumber] = useState("");
    const [userErrors, setUserErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [progress, setProgress] = useState(0);
    const [openSavePassword, setOpenSavePassword] = useState(false);
    const [success, setSuccess] = useState(false);
    const [createUserData, setCreateUserData] = useState(null);
    const [selectedProfileType, setSelectProfileType] = useState("")
    const [selectedIdType, setSelectedIdType] = useState("")
    const [selectedRole, setSelectedRole] = useState("")
    const [idNumber, setIdNumber] = useState('');
    const [errorMessage, setErrorMessage] = useState(); 
    const [statusCode, setStatusCode] = useState();
    
    const [filteredProfileTypes, setFilteredProfileTypes] = useState([]);

    const {enqueueSnackbar} = useSnackbar();

   useEffect(() => {
        if (profileTypes) {
            let filteredProfileTypesArray = [];

            if (organizationId) {
            // Show only "Business"
            filteredProfileTypesArray = profileTypes.filter((type) => type === "Business");
            } else {
            // Show everything except "Business"
            filteredProfileTypesArray = profileTypes.filter((type) => type !== "Business");
            }

            setFilteredProfileTypes(filteredProfileTypesArray);
        }
    }, [profileTypes, organizationId]);

    
    const navigate = useNavigate();

    const handleBack = () => {
        navigate("/user")
    };

    const handleClose = () => {
        setOpenSavePassword(false);
    }

    const handleChange = (setters) => (event) => {
        setters(event.target.value)
    }

    const validateEmailField = (value) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        setUserErrors((prev) => ({
            ...prev,
            email: value === ''
            ? 'Email is required'
            : !emailRegex.test(value)
            ? 'Invalid email format'
            : '',
        }));
    };

    const validateContactNumber = (value) => {
        const regex = /^\+63\d{10}$/; // Must start with +63 and be followed by 10 digits
        setUserErrors((prev) => ({
            ...prev,
            contact_no: value === ''
            ? 'Contact number is required'
            : !regex.test(value)
            ? 'Invalid format. Use +63XXXXXXXXXX'
            : '',
        }));
    };

    const today = dayjs();
    const maxAllowedDate = today.subtract(16, 'year');


    const handleSubmit = async () => {
        const userErrors = {};
    
        if (!firstname) userErrors.firstname = "First name is required";
        // if (!middlename) userErrors.middlename = "Middle name is required";
        if (!lastname) userErrors.lastname = "Last name is required";
        if (!email) userErrors.email = "Email is required";
        if (!contact_no) userErrors.contact_no = "Contact number is required";
        if (!birthdate) userErrors.birthdate = "Date of birth is required";
        if (!selectedProfileType) userErrors.profileType = "Profile type is required";
        if (!selectedIdType) userErrors.idType = "ID type is required";
        if (!selectedRole) userErrors.role = "Role is required";
        if (!idNumber) userErrors.idNumber = "ID number is required";

    
        setUserErrors(userErrors);
    
        if (Object.keys(userErrors).length > 0) {
            return;
        }
    
        // setErrorMessage(null);
        setLoading(true);
    
        try {
            const userPayload = {
                org_uid: organizationId ? organizationId : "",
                firstname,
                middlename,
                contact_no,
                lastname,
                email,
                profile_type: selectedProfileType,
                id_type: selectedIdType,
                id_no: idNumber,
                role: selectedRole,
                birthdate: birthdate ? dayjs(birthdate).format("YYYY-MM-DD") : null,

            };

            const userResponse = await UserService.createUser(userPayload);

            const userPassword = userResponse?.data?.data?.user ?? userResponse?.data?.data;

            setOpenSavePassword(true)
            setCreateUserData(userPassword)
            console.log('userResponse userResponse', userResponse)
            setSuccess(true);
            setLoading(false);
        } catch (error) {
             console.log('error error', error)
            // setErrorMessage(error.response.data.error_message);
            // setStatusCode(error?.response?.status || 500);
            const errorMessage = error?.response?.data?.error_message || error.message;
    
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        } finally {
            setLoading(false);
        }
    };

     useEffect(() => {
        const interval = setInterval(() => {
            setProgress((oldProgress) => {
                if (oldProgress >= 100) {
                    clearInterval(interval);
                    setLoading(false);
                    return 100;
                }
                return Math.min(oldProgress + 10, 100);
            });
        }, 500);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        getProfileTypesUtil();
        getIDTypesUtil();
    }, []);

    useEffect(() => { 
        if (selectedProfileType) {
            let parameters = {
                profileType: selectedProfileType,
            }
            getRoleByProfileType(parameters)
            setSelectedRole("")
        } 
    }, [selectedProfileType]);
    
    console.log('selected role', selectedRole)

    return (
        <>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1, }}
                open={loading}
            >
                <Box display="flex" flexDirection="column" alignItems="center" textAlign="center">
                    <CircularProgress
                        color="inherit"
                        value={progress} // Progress must be a value between 0 and 100
                        size={60}
                    />
                    <Typography mt={2} sx={{color:"#fff"}}>
                        Creating...
                    </Typography>
                </Box>
                
            </Backdrop>
            {errorMessage && (
                <Alert style={{marginBottom: "12px"}} severity="error">
                    {errorMessage}.
                    <Typography sx={{ fontSize: '0.5rem' }}>
                        Status Code: {statusCode}
                    </Typography>
                </Alert>
            )}
            
            <Container maxWidth="lg">
                <CustomButton
                    variant="text" 
                    startIcon={<ArrowBackIcon fontSize="small" />}
                    label="Back to User Management"
                    customStyles={{fontSize: 14, mt: 2}}
                    onClick={handleBack}
                />
                <Paper elevation={0} sx={{border: `1px solid #e5edf6`, borderRadius: 2, padding: "24px 32px", mt: 3}}>
                    <Box sx={{textAlign: "start", mb: 3}}>
                        <Typography variant="h6" >Create User</Typography>
                        <Typography>Add a new user with their profile details in one step.</Typography>
                    </Box>
                    <Grid container spacing={3}>
                        <Grid size={{ xs: 7 }} >
                            <Box component="form" sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                <Box>
                                    <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>
                                        First Name
                                    </Typography>
                                    
                                    <CustomTextField
                                        placeholder={"ex: Juan"}
                                        variant={"outlined"}
                                        value={firstname}
                                        onChange={(e) => setFirstname(e.target.value)}
                                        fullWidth={true}
                                        multiline={false}
                                        hiddenLabel
                                        helperText={userErrors.firstname}
                                    />
                                </Box>

                                <Box>
                                    <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>
                                        Middle Name
                                    </Typography>
                                    <CustomTextField
                                        placeholder={"Middle Name"}
                                        variant={"outlined"}
                                        value={middlename}
                                        onChange={(e) => setMiddleName(e.target.value)}
                                        fullWidth={true}
                                        multiline={false}
                                        hiddenLabel
                                        helperText={userErrors.middlename}
                                    />
                                </Box>

                                <Box>
                                    <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>
                                        Last Name
                                    </Typography>
                                    
                                   <CustomTextField
                                        placeholder={"ex: Dela Cruz"}
                                        variant={"outlined"}
                                        value={lastname}
                                        onChange={(e) => setLastname(e.target.value)}
                                        fullWidth={true}
                                        multiline={false}
                                        hiddenLabel
                                        helperText={userErrors.lastname}
                                    /> 
                                </Box>

                                <Box>
                                    <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>
                                        Email
                                    </Typography>
                                    
                                    <CustomTextField
                                        placeholder={"ex: juandelacruz@mail.com"}
                                        variant={"outlined"}
                                        value={email}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setEmail(value);
                                            validateEmailField(value);
                                        }}
                                        fullWidth={true}
                                        multiline={false}
                                        hiddenLabel
                                        helperText={userErrors.email}
                                    /> 
                                </Box>

                                <Box>
                                <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>
                                    Contact Number
                                </Typography>
                                <PhoneInput
                                    country={'ph'}
                                    value={contact_no}
                                    onChange={(value) => setContactNumber('+' + value)}
                                    inputStyle={{
                                        width: '100%',
                                        height: 45,
                                        borderRadius: 4,
                                        paddingLeft: 48,
                                        border:'1px solid #e5edf6'
                                    }}
                                    
                                    inputProps={{
                                    name: 'phone',
                                    required: true,
                                    }}
                                    enableSearch
                                />
                                {userErrors.contact_no && (
                                    <FormHelperText sx={{ color: 'error.main' }}>
                                    {userErrors.contact_no}
                                    </FormHelperText>
                                )}
                                </Box>

                                <Box>
                                <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>
                                    Date of Birth
                                </Typography>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                    value={birthdate}
                                    onChange={setBirthdate}
                                    style={{height: 45}}
                                    maxDate={maxAllowedDate}
                                    shouldDisableDate={(date) => date.isAfter(maxAllowedDate)}
                                    slotProps={{
                                        textField: {
                                            fullWidth: true,
                                            // error: !!userErrors.birthdate,
                                            helperText: userErrors.birthdate,
                                            sx: {
                                                '& .MuiInputBase-root': {
                                                    height: 50,
                                                    border:'1px solid #fff'
                                                }, '& .MuiFormHelperText-root': {
                                                    color: 'red',
                                                    fontSize: 11,
                                                    margin: 0
                                                }, '& .MuiOutlinedInput-root': {
                                                '& fieldset': {
                                                borderColor: '#e5edf6', // 🔵 default border color
                                                },
                                            },
                                            }
                                        },
                                    }}
                                    />
                                </LocalizationProvider>
                                </Box>
                            </Box>
                        </Grid>

                        <Grid size={{ xs: 5 }} sx={{ mt: 2 }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                <Typography sx={{ fontWeight: 'bold', mb: 1 }}>Profile</Typography>

                                <Box>
                                <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>
                                    Profile Type
                                </Typography>
                               <FormControl fullWidth 
                                    sx={{'& .MuiFormHelperText-root': {
                                        color: 'red',
                                        fontSize: 11,
                                        margin: 0
                                    }}}
                                >
                                <Select
                                    value={selectedProfileType}
                                    onChange={handleChange(setSelectProfileType)}
                                    displayEmpty
                                    inputProps={{ 'aria-label': 'Select Profile Type' }}
                                    renderValue={(selected) => {
                                        if (!selected) {
                                            return <Typography sx={{fontSize: 13, color: "#b8b8b8"}}>Select Profile Type</Typography>; // ⬅️ Placeholder text
                                        }
                                        return selected;
                                    }}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '4px',
                                            '& fieldset': {
                                            borderColor: '#e5edf6',
                                            },
                                        },
                                        '& .MuiSelect-select': {
                                            padding: '10px 14px',
                                            minHeight: '20px', // ✅ Controls the visible height
                                            display: 'flex',
                                            alignItems: 'center',
                                        }
                                    }}
                                >
                                    {filteredProfileTypes.map((name) => (
                                    <MenuItem key={name} value={name}>
                                        {name}
                                    </MenuItem>
                                    ))}
                                </Select>
                                {userErrors.profileType && (
                                    <FormHelperText>{userErrors.profileType}</FormHelperText>
                                )}
                                </FormControl>


                                </Box>

                                { selectedProfileType && (
                                    <Box>
                                    <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>
                                        Role
                                    </Typography>
                                    <FormControl fullWidth 
                                        sx={{'& .MuiFormHelperText-root': {
                                            color: 'red',
                                            fontSize: 11,
                                            margin: 0
                                        }}}
                                    >
                                        <Select
                                        value={selectedRole}
                                        onChange={handleChange(setSelectedRole)}
                                        renderValue={(selected) => {
                                            if (!selected) {
                                                return <Typography sx={{fontSize: 13, color: "#b8b8b8"}}>Select Role</Typography>; // ⬅️ Placeholder text
                                            }
                                            return selected;
                                        }}
                                        sx={{
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '4px',
                                            '& fieldset': {
                                            borderColor: '#e5edf6',
                                            },
                                        },
                                        '& .MuiSelect-select': {
                                            padding: '10px 14px',
                                            minHeight: '20px', // ✅ Controls the visible height
                                            display: 'flex',
                                            alignItems: 'center',
                                        },
                                        }}
                                        >
                                        {rolesList.map((role) => (
                                            <MenuItem key={role.role} value={role.role}>
                                            {role.role}
                                            </MenuItem>
                                        ))}
                                        </Select>
                                        {userErrors.role && (
                                        <FormHelperText>{userErrors.role}</FormHelperText>
                                        )}
                                    </FormControl>
                                    </Box>
                                )}

                                <Box>
                                <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>
                                    ID Type
                                </Typography>
                                <FormControl fullWidth 
                                    sx={{'& .MuiFormHelperText-root': {
                                        color: 'red',
                                        fontSize: 11,
                                        margin: 0
                                    }}}
                                >
                                    <Select
                                        value={selectedIdType}
                                        onChange={handleChange(setSelectedIdType)}
                                        displayEmpty
                                        renderValue={(selected) => {
                                        if (!selected) {
                                            return <Typography sx={{fontSize: 13, color: "#b8b8b8"}}>Select ID Type</Typography>; // ⬅️ Placeholder text
                                        }
                                        return selected;
                                        }}
                                        sx={{
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '4px',
                                            '& fieldset': {
                                            borderColor: '#e5edf6',
                                            },
                                        },
                                        '& .MuiSelect-select': {
                                            padding: '10px 14px',
                                            minHeight: '20px', // ✅ Controls the visible height
                                            display: 'flex',
                                            alignItems: 'center',
                                        },
                                        }}
                                        >
                                        {/* <MenuItem disabled value="">
                                            <em>Select Profile Type</em>
                                        </MenuItem> */}
                                        {idTypes.map((name) => (
                                            <MenuItem key={name} value={name}>
                                            {name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    {userErrors.idType && (
                                    <FormHelperText>{userErrors.idType}</FormHelperText>
                                    )}
                                </FormControl>
                                </Box>

                                <Box>
                                    <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>
                                        ID Number
                                    </Typography>
                                    <CustomTextField
                                        placeholder={"ID Number"}
                                        variant={"outlined"}
                                        value={idNumber}
                                        onChange={(e) => setIdNumber(e.target.value)}
                                        fullWidth={true}
                                        multiline={false}
                                        hiddenLabel
                                        helperText={userErrors.idNumber}
                                    /> 
                                </Box>
                            </Box>
                        </Grid>

                        <Grid size={{xs: 12}} sx={{ textAlign:'end', mt: 2 }} gap={2}>
                            <CustomButton
                                variant={"outlined"}
                                label={"Cancel"}
                                customStyles={{mr: 2}}
                                onClick={() => navigate("/user")}
                            />   
                            <CustomButton 
                                variant={"contained"}
                                label={"Create User"}
                                disabled={loading}
                                // startIcon={isLoadingCreateGate && <CircularProgress size="15px" color="#fff" sx={{mr: "2px"}} />}
                                onClick={handleSubmit}
                            />   
                            {/* <Button type="button" variant="contained" sx={{ alignSelf: 'flex-end' }} onClick={handleSubmit}>
                                Create User
                            </Button> */}
                        </Grid>
                    </Grid>
                </Paper>
                
            </Container>

            <CustomModal1
                open={openSavePassword}
                handleClose={handleClose}
                title="Save Password"
            >
                <SavePasswordDialogComponent createUserData={createUserData}/>
            </CustomModal1>
        </>
    );
}
